import { render, staticRenderFns } from "./UserWidget.vue?vue&type=template&id=2f879e6a&scoped=true&"
import script from "./UserWidget.vue?vue&type=script&lang=js&"
export * from "./UserWidget.vue?vue&type=script&lang=js&"
import style0 from "./UserWidget.vue?vue&type=style&index=0&id=2f879e6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f879e6a",
  null
  
)

export default component.exports